import {SpecialDay} from "../form/SpecialDay";
import {ISpecialDayDoc} from "../doc/ISpecialDayDoc";

export const specialDayAdapter = {
  toFirestore: (entity: SpecialDay): ISpecialDayDoc => ({
    date: entity.date,
    type: entity.type,
  }),

  fromFirestore: (id: string, data: ISpecialDayDoc): SpecialDay => ({
    id,
    date: data.date,
    type: data.type,
  }),
};